module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/G3r9hc/tc-custom/9781453276884.jpg?1718283488753",
      "alt": "This image is the cover for the book Sugar Baby Sampler"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sugar Baby Sampler\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A selection of "), _c('i', [_vm._v("Sugar Baby")]), _vm._v(" recipes to get you started")]), _c('br'), _vm._v("Cookbooks with recipes for baking with sugar (in the oven) continue to top the bestseller lists. But until now, no one has set out to do a cookbook with recipes on cooking with sugar (on the stovetop). The "), _c('i', [_vm._v("Sugar Baby Sampler")]), _vm._v(" gives a taste of the full "), _c('i', [_vm._v("Sugar Baby ")]), _vm._v("cookbook, including three of Gesine Bullock-Prado’s recipes for candy, confections, and treats. With the simplest instructions and the author’s hilarious voice, the "), _c('i', [_vm._v("Sugar Baby Sampler")]), _vm._v(" offers a delicious selection of the one hundred recipes found in "), _c('i', [_vm._v("Sugar Baby")]), _vm._v(", which will satisfy even the most demanding sweet tooth.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tina Rupp, Gesine Bullock-Prado\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gesine Bullock-Prado is the founder of the Gesine Confectionary product line and author of "), _c('i', [_vm._v("My Life from Scratch")]), _vm._v(". She lives in Hartford, Vermont, with two dogs, seven chickens, ten Indian Runner ducks, six geese, two goats, and one wonderful husband. She cooks with her animals’ eggs and milk, as well as produce from her garden. She has been featured in "), _c('i', [_vm._v("People")]), _vm._v(" and many other national publications; she has also appeared on the Food Network, the "), _c('i', [_vm._v("Rachael Ray Show")]), _vm._v(", and the "), _c('i', [_vm._v("Today Show")]), _vm._v(".  ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0